import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesFaturamento {
  ler: boolean;
}

/**
 * Espelho, no frontend, do RBAC real da rota `/api/v1/faturamento`
 * (`autorizar(authService, 'financeiro', 'ler')`) — mesmo recurso que
 * `/financeiro`. `admin` (curinga) e o papel `financeiro`. Nenhum outro
 * papel acessa. Só decide o que mostrar; o backend sempre revalida.
 */
export function permissoesFaturamento(papel: PapelUsuario): PermissoesFaturamento {
  return { ler: papel === 'admin' || papel === 'financeiro' };
}
